import client from "../../api/client"

export default function useShare() {
    return {
        getGameCode,
        getGameId,
    }
}

function getGameCode(gameId: string): Promise<string> {
    return client.getShareCodeByGameId(gameId)   
}

function getGameId(gameCode: string): Promise<string> {
    return client.getGameIdByShareCode(gameCode)
}